import React, { Component } from 'react'

import './_stepButton.css'

class StepButton extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  }

  static defaultProps = {
    title: 'Кнопка',
    icon: false,
    small: false,
    navigateTo: '',
    onNavigate: () => {}
  }

  handleClick = () => {
    if(this.props.navigateTo !== '') {
      this.context.router.push(this.props.navigateTo)
    }
    this.props.onNavigate()
  }

  render() {
    const { title, icon, small } = this.props

    return(
      <button className={`step-button ${(icon) ? 'iconic' : ''} ${(small) ? 'small' : ''}`} onClick={this.handleClick}>
        <span>{title}</span>
      </button>
    )
  }
}

export default StepButton


// WEBPACK FOOTER //
// ./src/components/step-button/StepButton.js